import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChange, SimpleChanges } from '@angular/core';
import { Issue } from "../../../../../shared/models/issue.model";
import { TableConfig } from "../../../../../shared/util/table-config.utils";
import { Reason } from "../../../../../shared/models/reason.model";
import { Log } from "ng2-logger";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: 'app-issue-table',
    templateUrl: './issue-table.component.html',
    styleUrls: ['./issue-table.component.scss']
})
export class IssueTableComponent implements OnInit, OnChanges {
    _logger = Log.create(IssueTableComponent.name);
    @Input() issues: Issue[] = [];
    @Input() reasons: Reason[] = [];
    @Input() tableConfig: TableConfig;
    @Input() isLoading = false;
    @Input() headerBackgroundColor: string;
    @Input() hasTitle = true;

    @Output() pageChange = new EventEmitter<any>();
    @Output() filterChange = new EventEmitter<any>();
    @Output() sortChange = new EventEmitter<any>();
    @Output() rowClick = new EventEmitter<any>();

    filterReasons = [];

    constructor(private translateService: TranslateService) {
    }

    ngOnInit(): void {
        this.translateService.onLangChange.subscribe((event) => {
            this.filterReasons = this.buildTranslateKeys();
        });
    }

    ngOnChanges(changes: { [propName: string]: SimpleChange }): void {
        if (changes['reasons'] && changes['reasons'].previousValue !== changes['reasons'].currentValue &&
            !changes['reasons'].firstChange) {
            this.filterReasons = this.buildTranslateKeys()
        }
    }

    onPageChange(tableConfig: TableConfig) {
        this._logger.info('onPageChange::', tableConfig);
        this.pageChange.emit(tableConfig);
    }

    onSortChange(tableConfig: TableConfig) {
        this._logger.info('onSortChange::', tableConfig);
        this.sortChange.emit(tableConfig);
    }

    onFilterChange(tableConfig: TableConfig) {
        this._logger.info('onFilterChange::', tableConfig);
        this.filterChange.emit(tableConfig);
    }

    onRowClick(clickedItem) {
        this._logger.info('onRowClick::', clickedItem);
        this.rowClick.emit(clickedItem);
    }

    buildTranslateKeys() {
        const filterReasons = [
            {name: this.translateService.instant('generic.statuses.all'), value: 'All'},
        ];

        this.reasons.forEach(reason => {
            filterReasons.push({name: reason.name, value: reason.name});
        });
        return filterReasons;
    }


}
